import { createSlice } from '@reduxjs/toolkit'

const initialState = {
  value: {},
  loading: false,
}

export const AddAdminStaffSlice = createSlice({
  name: 'AddAdminStaff',
  initialState,
  reducers: {
    AddAdminStaff_request: (state, action) => {
      state.value = {};
      state.loading = true;
    },
    AddAdminStaff_success: (state, action) => {

      state.value = action.payload;
      state.loading = false;
      state.error = {};

    },
    AddAdminStaff_failure: (state, action) => {
      state.error = action.payload;
      state.loading = false;
      state.value = {};
    },
    Clear_AddAdminStaff_Check: (state, action) => {
      state.value = {}
      state.error = {};
      state.loading = false;
    },
  }
})

// Action creators are generated for each case reducer function
export const {AddAdminStaff_request, AddAdminStaff_success, AddAdminStaff_failure, Clear_AddAdminStaff_Check } = AddAdminStaffSlice.actions

export default AddAdminStaffSlice.reducer